/* eslint-disable no-shadow */
import FetchStatus from "@/constants/fetch-status/FetchStatus";
import { ShaftType } from "@/constants/enums/Enums";
import { httpV2 } from "@/api/index";
import {
	GET_STAGE_3_BROKEN_TEETH_RESULT,
	GET_STAGE_3_BROKEN_TEETH_RESULT_SUCCESS,
	GET_STAGE_3_BROKEN_TEETH_RESULT_ERROR,
	RESET_STAGE_3_BROKEN_TEETH_RESULT,
} from "@/stores/actions/WindDiagnosticGearboxStageThreeBrokenTeethResult";

const state = {
	status: FetchStatus.Init,
	data:   {
		hssResult:        0,
		imsResult:        0,
		signalSettingIds: []
	},
	error: {},
};
  
const actions = {
	async [GET_STAGE_3_BROKEN_TEETH_RESULT]({ commit }, resultSetId)
	{
	  commit(GET_STAGE_3_BROKEN_TEETH_RESULT);
  
	  try
		{
			const [ hss, ims ] = await Promise.all([
		  httpV2.get(`/WindTurbinesDiagnostic/${resultSetId}/${ShaftType.HSS}/GearboxStage3BrokenTeeth`),
		  httpV2.get(`/WindTurbinesDiagnostic/${resultSetId}/${ShaftType.IMS}/GearboxStage3BrokenTeeth`),
			]);
  
			commit(GET_STAGE_3_BROKEN_TEETH_RESULT_SUCCESS, {
		  hssResult: hss.data,
		  imsResult: ims.data,
			});
	  }
		catch (error)
		{
			commit(GET_STAGE_3_BROKEN_TEETH_RESULT_ERROR, error.response);
	  }
	},
	[RESET_STAGE_3_BROKEN_TEETH_RESULT]({ commit })
	{
	  commit(RESET_STAGE_3_BROKEN_TEETH_RESULT);
	},
};
  
const mutations = {
	[GET_STAGE_3_BROKEN_TEETH_RESULT](state)
	{
	  state.status = FetchStatus.Loading;
	},
	[GET_STAGE_3_BROKEN_TEETH_RESULT_SUCCESS](state, { hssResult, imsResult })
	{
	  state.status = FetchStatus.Loaded;
	  state.data.hssResult = hssResult;
	  state.data.imsResult = imsResult;
	},
	[GET_STAGE_3_BROKEN_TEETH_RESULT_ERROR](state, error)
	{
	  state.status = FetchStatus.Error;
	  state.error = error;
	},
	[RESET_STAGE_3_BROKEN_TEETH_RESULT](state)
	{
	  state.status = FetchStatus.Init;
	  state.data.hssResult = 0;
	  state.data.imsResult = 0;
	},
};
  
export default {
	state,
	actions,
	mutations,
};
